<template>
    <div class="container">
      <section class="tweets_wrapper">
        <div class="title_2">
          <h1><img src="@/assets/images/twitter_icon.svg" alt="twitter_icon.svg"> Twitter </h1>
        </div>

        <section class="twitter_slider" v-if="tweets.length">
          <ul>
            <VueSlick v-bind="slickSettings">
              <li v-for="tweet in tweets" :key="tweet.id">
                <div class="tweet_box">
                  <div class="user_detail">
                    <div class="user_account">
                      <a href="https://twitter.com/gmnanashi" target="_blank">
                        <img :src="user.profile_image_url" alt="person_icon.svg">
                      </a>
                      <div class="user_name">
                        <h6>{{user.name}}</h6>
                        <p>@{{user.username}}</p>
                      </div>
                    </div>
                    <div class="user_more">
                      <a :href="tweet.url" title="View in twitter" target="_blank">
                        <i class="fab fa-twitter"></i>
                      </a>
                    </div>
                  </div>

                  <div class="tweet_content">
                    <h6 v-html="tweet.html_text"></h6>
                  </div>
                  <div class="tweet_time">
                    <p>{{tweet.created_at}} . {{tweet.source}}</p>
                  </div>

                </div>
              </li>
            </VueSlick>
          </ul>

        </section>

      </section>
    </div>
</template>

<script>
export default{
  name: 'TwitterFeed',
  data () {
    return {
      tweets: '',
      user: '',
      slickSettings: {
        dots: false,
        infinite: false,
        arrows: true,
        swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: true,
        autoplay: false,
        autoplaySpeed: 1500,
        variableWidth: false,
        centerMode: false,
        fade: false,
        cssEase: 'linear',
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.5
          }
        },

        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },

        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        }
        ]
      }
    }
  },
  mounted () {
    this.fetchTweets()
  },
  methods: {
    fetchTweets () {
      this.$store
        .dispatch('fetchTweets')
        .then((resp) => {
          this.tweets = resp.data.tweets
          this.user = resp.data.user
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}
</script>

<style scoped>
.user_more .fab {
  color: #a0a0a0
}
</style>



// WEBPACK FOOTER //
// src/components/TwitterFeed.vue